export default __webpack_public_path__ + "assets/a48884925dffd119a8fb17f05db9d22d.jpeg";